/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'goal-content.goal-about-content.description-title': 'Beschreibung',
  'goal-content.goal-about-content.placeholder-description':
    'Beschreiben Sie kurz, warum dieses Ziel so wichtig ist und wie Erfolg gemessen wird, damit Sie Followern ein einheitliches Verständnis vermitteln können.',
  'goal-content.goal-content-updates.add-update': 'Update hinzufügen',
  'goal-content.goal-content-updates.archived': 'Archiviert',
  'goal-content.goal-content-updates.at-risk': 'In Gefahr',
  'goal-content.goal-content-updates.cancelled': 'Abgebrochen',
  'goal-content.goal-content-updates.completed': 'Abgeschlossen 🎉',
  'goal-content.goal-content-updates.date-changed': 'Datum geändert',
  'goal-content.goal-content-updates.edit-update': 'Bearbeiten',
  "goal-content.goal-content-updates.for-date'": 'für den {dueDate}',
  'goal-content.goal-content-updates.latest-update-title': 'Neuestes Update',
  'goal-content.goal-content-updates.missed-update-message': 'Es wurde kein Update veröffentlicht.',
  'goal-content.goal-content-updates.new-due-date': 'Neues Fälligkeitsdatum',
  'goal-content.goal-content-updates.new-state': 'Neuer Status',
  'goal-content.goal-content-updates.no-updates-description': 'Für dieses Ziel sind noch keine Updates vorhanden.',
  'goal-content.goal-content-updates.off-track': 'Nicht auf Kurs',
  'goal-content.goal-content-updates.old-due-date': 'Altes Fälligkeitsdatum',
  'goal-content.goal-content-updates.old-state': 'Alter Status',
  'goal-content.goal-content-updates.on-track': 'Auf Kurs',
  'goal-content.goal-content-updates.paused': 'Angehalten',
  'goal-content.goal-content-updates.pending': 'Ausstehend',
  'goal-content.goal-content-updates.previous-updates-title': 'Vorherige Updates',
  'goal-content.goal-content-updates.share-update': 'Teilen',
  'goal-content.goal-content-updates.status-changed': 'Status geändert',
  'goal-content.goal-content-updates.write-update-button': 'Ein Update schreiben',
};
